import Login from './login';

const Index = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default Index;
